import { APIModel } from '@shared/interfaces';

export class TaxResponseDocument implements APIModel {
    id = -1;
    url = '';
    filename = '';
    uuid = '';

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.url = data.file ?? '';
        this.filename = this.url.substring((this.url.lastIndexOf('/') ?? -1) + 1).split('?')[0];
        this.uuid = data.uuid ?? '';
        return this;
    }
}
